import constants from "./constants";
import createAction from "sagas/createAction";
import { createPromiseAction } from "@adobe/redux-saga-promise";

const actions = {
  setFacebookSettings: createPromiseAction(constants.SET_FACEBOOK_SETTINGS),
  setFacebookConversionStatus: createPromiseAction(constants.SET_FACEBOOK_CONVERSION_STATUS),
  setFacebookConversionSettingStatus: createPromiseAction(constants.SET_FACEBOOK_CONVERSION_SETTING_STATUS),
  getFacebookSettings: createPromiseAction(constants.GET_FACEBOOK_SETTINGS),
  getFacebookDaSettings: createPromiseAction(constants.GET_FACEBOOK_DA_SETTINGS),
  getFacebookApiToken: createPromiseAction(constants.GET_FACEBOOK_API_TOKEN),
  getFacebookBusinessList: createPromiseAction(constants.GET_FACEBOOK_BUSINESS_LIST),
  getFacebookAdsAccountList: createPromiseAction(constants.GET_FACEBOOK_ADS_ACCOUNT_LIST),
  getFacebookPixelCodeList: createPromiseAction(constants.GET_FACEBOOK_PIXEL_CODE_LIST),
  getFacebookPixelAgencies: createPromiseAction(constants.GET_FACEBOOK_PIXEL_AGENCIES),
  getFacebookConversionLastSent: createPromiseAction(constants.GET_FACEBOOK_CONVERSION_LAST_SENT),
  getFacebookCRMConversionLastSent: createPromiseAction(constants.GET_FACEBOOK_CRM_CONVERSION_LAST_SENT),
  getFacebookConversionSettingByPipeline: createPromiseAction(constants.GET_FACEBOOK_CONVERSION_SETTING_BY_PIPELINE),
  getFacebookAdsAccountAgencies: createPromiseAction(constants.GET_FACEBOOK_ADS_ACCOUNT_AGENCIES),
  inviteFacebookAdsAccount: createPromiseAction(constants.INVITE_FACEBOOK_ADS_ACCOUNT),
  inviteFacebookPixels: createPromiseAction(constants.INVITE_FACEBOOK_PIXELS),
  syncFacebookSettingWithRdynamic: createPromiseAction(constants.SYNC_FACEBOOK_SETTING_WITH_RDYNAMIC),
  syncFacebookSettingWithRmp: createPromiseAction(constants.SYNC_FACEBOOK_SETTING_WITH_RMP),
  changeSettingPage: (page) => createAction(constants.CHANGE_FACEBOOK_SETTING_PAGE, { page }),

  rwidgetConversionDefaultValue: (params) => createAction(constants.RWIDGET_CONVERSION_DEFAULT_VALUE, { params }),
  getRwidgetConversionDefaultValue: createPromiseAction(constants.GET_RWIDGET_CONVERSION_DEFAULT_VALUE),
  getFacebookPageId: createPromiseAction(constants.GET_FACEBOOK_PAGE_ID),
  getFacebookFormList: createPromiseAction(constants.GET_FACEBOOK_FORM_LIST),
  getAllLeadFormSettings: createPromiseAction(constants.GET_ALL_LEAD_FORM_SETTINGS),
  setFacebookAccount: createPromiseAction(constants.SET_FACEBOOK_ACCOUNT),
  getFacebookAccount: createPromiseAction(constants.GET_FACEBOOK_ACCOUNT),
  switchLeadFormStatus: createPromiseAction(constants.SWITCH_LEAD_FORM_STATUS),
  getLeadFormSetting: createPromiseAction(constants.GET_LEAD_FORM_SETTING),
  getFacebookPageSetting: createPromiseAction(constants.GET_FACEBOOK_PAGE_SETTING),
  getGoogleSetting: createPromiseAction(constants.GET_GOOGLE_SETTING),
  getCRMSetting: createPromiseAction(constants.GET_CRM_SETTING),
  setLeadFormSetting: createPromiseAction(constants.SET_LEAD_FORM_SETTING),
  getPageSetting: createPromiseAction(constants.GET_PAGE_SETTING),
  getFacebookUserInfo: createPromiseAction(constants.GET_FACEBOOK_USER_INFO),
  getFacebookNewAccessToken: createPromiseAction(constants.GET_FACEBOOK_NEW_ACCESS_TOKEN),
  getFacebookPageAccessToken: createPromiseAction(constants.GET_FACEBOOK_PAGE_ACCESS_TOKEN),
  getFacebookPageByUserId: createPromiseAction(constants.GET_FACEBOOK_PAGE_BY_USER_ID),
  changePageUrlInput: (pageUrl) => createAction(constants.CHANGE_PAGE_URL_INPUT, { pageUrl }),
  changePageFormSelectType: (pageFormSelectType) =>
    createAction(constants.CHANGE_PAGE_FORM_SELECT_TYPE, { pageFormSelectType }),
  setCheckedFormItems: (checkedFormItems) => createAction(constants.SET_CHECKED_FORM_ITEMS, { checkedFormItems }),
  archiveLeadFormSetting: createPromiseAction(constants.ARCHIVE_LEAD_FORM_SETTING),
  setFbConnected: (fbConnected) => createAction(constants.SET_FB_CONNECTED, { fbConnected }),
  setFbDisconnected: (fbDisconnected) => createAction(constants.SET_FB_DISCONNECTED, { fbDisconnected }),
  setGoogleConnected: (googleConnected) => createAction(constants.SET_GOOGLE_CONNECTED, { googleConnected }),
  setGoogleDisconnected: (googleDisconnected) =>
    createAction(constants.SET_GOOGLE_DISCONNECTED, { googleDisconnected }),
  changeSheetsUrlInput: (sheetsUrl) => createAction(constants.CHANGE_SHEETS_URL_INPUT, { sheetsUrl }),
  getFacebookPageList: createPromiseAction(constants.GET_FACEBOOK_PAGE_LIST),
  getUserAccessToken: createPromiseAction(constants.GET_USER_ACCESS_TOKEN),
  getFacebookPageListMore: createPromiseAction(constants.GET_FACEBOOK_PAGE_LIST_MORE),
  setValidateFacebookLeadForm: (validateForm) =>
    createAction(constants.SET_VALIDATE_FACEBOOK_LEAD_FORM, { validateForm }),
  setDuplicateFacebookForm: (duplicateForm) => createAction(constants.SET_DUPLICATE_FACEBOOK_FORM, { duplicateForm }),
  getGoogleSheetsCRMConversionsLastSend: createPromiseAction(constants.GET_GOOGLE_SHEETS_CRM_CONVERSIONS_LAST_SEND),
  getDetailsPixelId: createPromiseAction(constants.GET_DETAILS_PIXEL_ID),
  updateSheetsModifiedData: (updatedData) => createAction(constants.UPDATE_SHEETS_MODIFIED_DATA, { updatedData }),
  updateFBLeadFormSettingErrorStatus: createPromiseAction(constants.UPDATE_FB_LEAD_FORM_SETTING_ERROR_STATUS),
  setFileInfoError: (fileInfoError) => createAction(constants.SET_FILE_INFO_ERROR, { fileInfoError }),
  setFacebookLoading: (loading) => createAction(constants.SET_FACEBOOK_LOADING, { loading }),
  setFacebookFormLoading: (loading) => createAction(constants.SET_FACEBOOK_FORM_LOADING, { loading }),
  setFacebookError: (error) => createAction(constants.SET_FACEBOOK_ERROR, { error }),
  setFBConnectionLoading: (loading) => createAction(constants.SET_FB_CONNECTION_LOADING, { loading }),
  setCRMConversionsLoading: (loading) => createAction(constants.SET_CRM_CONVERSIONS_LOADING, { loading }),
};

export default actions;
